// extracted by mini-css-extract-plugin
module.exports = {"baseEntry":"BaseEntry_baseEntry__338J7"};